

// src/components/pages/Companies.jsx
// import React, { useState, useEffect, useContext } from 'react'; // Add useContext
// import { Link } from 'react-router-dom';
// import { getCompanies, createCompany, updateCompany, deleteCompany } from "../../services/api";
// import { useAuth } from "../../contexts/AuthContext"; // Change this line
// import './Companies.css';

// const Companies = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth(); // Change this line
  
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editingCompany, setEditingCompany] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterIndustry, setFilterIndustry] = useState('all');
//   const [filterStatus, setFilterStatus] = useState('all');
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";
  
//   const [formData, setFormData] = useState({
//     name: '',
//     industry: '',
//     contact_person: '',
//     email: '',
//     phone: '',
//     address: '',
//     status: 'Active',
//     website: '',
//     description: '',
//     founded_year: ''
//   });

//   useEffect(() => {
//     loadCompanies();
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterIndustry, filterStatus]);

//   const loadCompanies = async () => {
//   try {
//     const res = await getCompanies();
//     setCompanies(res.data);
//     setLoading(false);
//   } catch (error) {
//     console.error(error);
//     setLoading(false);
//   }
// };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (editingCompany) {
//       await updateCompany(editingCompany.id, formData);
//     } else {
//       await createCompany(formData);
//     }
    
//     resetForm();
//     loadCompanies();
//     setShowModal(false);
//   };

//   const handleEdit = (company) => {
//     // Only admin can edit
//     if (!isAdmin) {
//       alert("You don't have permission to edit companies");
//       return;
//     }
//     setEditingCompany(company);
//     setFormData(company);
//     setShowModal(true);
//   };

//   const handleDelete = async(id) => {
//     // Only admin can delete
//     if (!isAdmin) {
//       alert("You don't have permission to delete companies");
//       return;
//     }
//     if (window.confirm('Are you sure you want to delete this company?')) {
//       await deleteCompany(id);
//       loadCompanies();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       industry: '',
//       contact_person: '',
//       email: '',
//       phone: '',
//       address: '',
//       status: 'Active',
//       website: '',
//       description: '',
//       founded_year: ''
//     });
//     setEditingCompany(null);
//   };

//   // Filter companies
//   const filteredCompanies = companies.filter(company => {
//     const matchesSearch = 
//       company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       company.contact_person.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       company.email.toLowerCase().includes(searchTerm.toLowerCase());
    
//     const matchesIndustry = filterIndustry === 'all' || company.industry === filterIndustry;
//     const matchesStatus = filterStatus === 'all' || company.status === filterStatus;
    
//     return matchesSearch && matchesIndustry && matchesStatus;
//   });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

//   // Pagination handlers
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   // Get unique industries and stats
//   const industries = ['all', ...new Set(companies.map(c => c.industry).filter(Boolean))];
//   const activeCompanies = companies.filter(c => c.status === 'Active').length;

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading companies...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="companies-page">
//       {/* Page Header */}
//       <div className="page-header">
//         <div>
//           <h1>Companies</h1>
//           <p>Manage client companies and their details</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         <button onClick={() => setShowModal(true)} className="btn-primary">
//           <span className="btn-icon">+</span> Add Company
//         </button>
//       </div>

//       {/* Stats */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{companies.length}</h3>
//             <p>Total Companies</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCompanies}</h3>
//             <p>Active Companies</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📊</div>
//           <div className="stat-content">
//             <h3>{industries.length - 1}</h3>
//             <p>Industries</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Search companies by name, contact, or email..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         <div className="filter-controls">
//           <select 
//             value={filterIndustry} 
//             onChange={(e) => setFilterIndustry(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Industries</option>
//             {industries.filter(i => i !== 'all').map(industry => (
//               <option key={industry} value={industry}>{industry}</option>
//             ))}
//           </select>
          
//           <select 
//             value={filterStatus} 
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//           </select>
//         </div>
//       </div>

//       {/* Companies Table with Pagination */}
//       <div className="table-container">
//         {filteredCompanies.length > 0 ? (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Company</th>
//                   <th>Industry</th>
//                   <th>Contact</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map(company => (
//                   <tr key={company.id}>
//                     <td>
//                       <div className="company-cell">
//                         <div className="company-avatar">
//                           {company.name.charAt(0)}
//                         </div>
//                         <div className="company-info">
//                           <Link to={`/company/${company.id}/jobs`} className="company-name">
//                             {company.name}
//                           </Link>
//                           <span className="company-website">{company.website || 'No website'}</span>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <span className="industry-badge">{company.industry || 'N/A'}</span>
//                     </td>
//                     <td>{company.contact_person || 'N/A'}</td>
//                     <td>
//                       <a href={`mailto:${company.email}`} className="email-link">
//                         {company.email || 'N/A'}
//                       </a>
//                     </td>
//                     <td>{company.phone || 'N/A'}</td>
//                     <td>
//                       <span className={`status-badge ${company.status === 'Active' ? 'active' : 'inactive'}`}>
//                         {company.status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         {/* Edit Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleEdit(company)} 
//                             className="action-btn edit"
//                             title="Edit"
//                           >
//                             ✏️
//                           </button>
//                         )}
                        
//                         <Link 
//                           to={`/company/${company.id}/jobs`} 
//                           className="action-btn view"
//                           title="View Jobs"
//                         >
//                           👁️
//                         </Link>
                        
//                         {/* Delete Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleDelete(company.id)} 
//                             className="action-btn delete"
//                             title="Delete"
//                           >
//                             🗑️
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCompanies.length)} of {filteredCompanies.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   {/* Page Numbers */}
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">🏢</div>
//             <h3>No companies found</h3>
//             <p>Try adding a new company or adjust your search filters</p>
//             <button onClick={() => setShowModal(true)} className="btn-primary">
//               Add Your First Company
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h2>{editingCompany ? 'Edit Company' : 'Add New Company'}</h2>
//               <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
//                 ×
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Company Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       placeholder="Enter company name"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Industry *</label>
//                     <input
//                       type="text"
//                       name="industry"
//                       value={formData.industry}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Technology, Finance"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Contact Person *</label>
//                     <input
//                       type="text"
//                       name="contact_person"
//                       value={formData.contact_person}
//                       onChange={handleInputChange}
//                       placeholder="Enter contact person name"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       placeholder="contact@company.com"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder="+91 9876543210"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Website</label>
//                     <input
//                       type="url"
//                       name="website"
//                       value={formData.website}
//                       onChange={handleInputChange}
//                       placeholder="https://company.com"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Founded Year</label>
//                     <input
//                       type="number"
//                       name="founded_year"
//                       value={formData.founded_year}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 2010"
//                       min="1900"
//                       max="2024"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Address</label>
//                   <textarea
//                     name="address"
//                     value={formData.address}
//                     onChange={handleInputChange}
//                     rows="2"
//                     placeholder="Enter company address"
//                     className="form-textarea"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     rows="3"
//                     placeholder="Brief description about the company"
//                     className="form-textarea"
//                   />
//                 </div>
//               </div>
              
//               <div className="modal-footer">
//                 <button type="submit" className="btn-primary">
//                   {editingCompany ? 'Update Company' : 'Add Company'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { resetForm(); setShowModal(false); }}
//                   className="btn-secondary"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Companies;













// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { getCompanies, createCompany, updateCompany, deleteCompany } from "../../services/api";
// import { useAuth } from "../../contexts/AuthContext";
// import './Companies.css';

// const Companies = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editingCompany, setEditingCompany] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterIndustry, setFilterIndustry] = useState('all');
//   const [filterStatus, setFilterStatus] = useState('all');
  
//   // View Modal States
//   const [viewingCompany, setViewingCompany] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";
  
//   const [formData, setFormData] = useState({
//     name: '',
//     industry: '',
//     contact_person: '',
//     email: '',
//     phone: '',
//     address: '',
//     status: 'Active',
//     website: '',
//     description: '',
//     founded_year: ''
//   });

//   useEffect(() => {
//     loadCompanies();
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterIndustry, filterStatus]);

//   const loadCompanies = async () => {
//     try {
//       const res = await getCompanies();
//       setCompanies(res.data);
//       setLoading(false);
//     } catch (error) {
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (editingCompany) {
//       await updateCompany(editingCompany.id, formData);
//     } else {
//       await createCompany(formData);
//     }
    
//     resetForm();
//     loadCompanies();
//     setShowModal(false);
//   };

//   // View handler for Company
//   const handleView = (company) => {
//     setViewingCompany(company);
//     setShowViewModal(true);
//   };

//   const handleEdit = (company) => {
//     // Only admin can edit
//     if (!isAdmin) {
//       alert("You don't have permission to edit companies");
//       return;
//     }
//     setEditingCompany(company);
//     setFormData(company);
//     setShowModal(true);
//   };

//   const handleDelete = async(id) => {
//     // Only admin can delete
//     if (!isAdmin) {
//       alert("You don't have permission to delete companies");
//       return;
//     }
//     if (window.confirm('Are you sure you want to delete this company?')) {
//       await deleteCompany(id);
//       loadCompanies();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       industry: '',
//       contact_person: '',
//       email: '',
//       phone: '',
//       address: '',
//       status: 'Active',
//       website: '',
//       description: '',
//       founded_year: ''
//     });
//     setEditingCompany(null);
//   };

//   // Filter companies
//   const filteredCompanies = companies.filter(company => {
//     const matchesSearch = 
//       company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       (company.contact_person && company.contact_person.toLowerCase().includes(searchTerm.toLowerCase())) ||
//       (company.email && company.email.toLowerCase().includes(searchTerm.toLowerCase()));
    
//     const matchesIndustry = filterIndustry === 'all' || company.industry === filterIndustry;
//     const matchesStatus = filterStatus === 'all' || company.status === filterStatus;
    
//     return matchesSearch && matchesIndustry && matchesStatus;
//   });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

//   // Pagination handlers
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   // Get unique industries and stats
//   const industries = ['all', ...new Set(companies.map(c => c.industry).filter(Boolean))];
//   const activeCompanies = companies.filter(c => c.status === 'Active').length;

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading companies...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="companies-page">
//       {/* Page Header */}
//       <div className="page-header">
//         <div>
//           <h1>Companies</h1>
//           <p>Manage client companies and their details</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         {isAdmin && (
//           <button onClick={() => setShowModal(true)} className="btn-primary">
//             <span className="btn-icon">+</span> Add Company
//           </button>
//         )}
//       </div>

//       {/* Stats */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{companies.length}</h3>
//             <p>Total Companies</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCompanies}</h3>
//             <p>Active Companies</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📊</div>
//           <div className="stat-content">
//             <h3>{industries.length - 1}</h3>
//             <p>Industries</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Search companies by name, contact, or email..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         <div className="filter-controls">
//           <select 
//             value={filterIndustry} 
//             onChange={(e) => setFilterIndustry(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Industries</option>
//             {industries.filter(i => i !== 'all').map(industry => (
//               <option key={industry} value={industry}>{industry}</option>
//             ))}
//           </select>
          
//           <select 
//             value={filterStatus} 
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//           </select>
//         </div>
//       </div>

//       {/* Companies Table with Pagination */}
//       <div className="table-container">
//         {filteredCompanies.length > 0 ? (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Company</th>
//                   <th>Industry</th>
//                   <th>Contact</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map(company => (
//                   <tr key={company.id}>
//                     <td>
//                       <div className="company-cell">
//                         <div className="company-avatar">
//                           {company.name.charAt(0)}
//                         </div>
//                         <div className="company-info">
//                           <div className="company-name" style={{ cursor: 'pointer', color: '#0B5FA5', fontWeight: '500' }}>
//                             {company.name}
//                           </div>
//                           <span className="company-website">{company.website || 'No website'}</span>
//                         </div>
//                       </div>
//                     </td>
//                      <td>
//                       <span className="industry-badge">{company.industry || 'N/A'}</span>
//                      </td>
//                      <td>{company.contact_person || 'N/A'}</td>
//                      <td>
//                       <a href={`mailto:${company.email}`} className="email-link">
//                         {company.email || 'N/A'}
//                       </a>
//                      </td>
//                      <td>{company.phone || 'N/A'}</td>
//                      <td>
//                       <span className={`status-badge ${company.status === 'Active' ? 'active' : 'inactive'}`}>
//                         {company.status}
//                       </span>
//                      </td>
//                      <td>
//                       <div className="action-buttons">
//                         {/* View Button - Opens Modal */}
//                         <button 
//                           onClick={() => handleView(company)} 
//                           className="action-btn view"
//                           title="View Company Details"
//                         >
//                           👁️
//                         </button>
                        
//                         {/* Edit Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleEdit(company)} 
//                             className="action-btn edit"
//                             title="Edit"
//                           >
//                             ✏️
//                           </button>
//                         )}
                        
//                         {/* Delete Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleDelete(company.id)} 
//                             className="action-btn delete"
//                             title="Delete"
//                           >
//                             🗑️
//                           </button>
//                         )}
//                       </div>
//                      </td>
//                    </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCompanies.length)} of {filteredCompanies.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   {/* Page Numbers */}
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">🏢</div>
//             <h3>No companies found</h3>
//             <p>Try adding a new company or adjust your search filters</p>
//             {isAdmin && (
//               <button onClick={() => setShowModal(true)} className="btn-primary">
//                 Add Your First Company
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h2>{editingCompany ? 'Edit Company' : 'Add New Company'}</h2>
//               <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
//                 ×
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Company Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       placeholder="Enter company name"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Industry *</label>
//                     <input
//                       type="text"
//                       name="industry"
//                       value={formData.industry}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Technology, Finance"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Contact Person *</label>
//                     <input
//                       type="text"
//                       name="contact_person"
//                       value={formData.contact_person}
//                       onChange={handleInputChange}
//                       placeholder="Enter contact person name"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       placeholder="contact@company.com"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder="+91 9876543210"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Website</label>
//                     <input
//                       type="url"
//                       name="website"
//                       value={formData.website}
//                       onChange={handleInputChange}
//                       placeholder="https://company.com"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Founded Year</label>
//                     <input
//                       type="number"
//                       name="founded_year"
//                       value={formData.founded_year}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 2010"
//                       min="1900"
//                       max="2024"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Address</label>
//                   <textarea
//                     name="address"
//                     value={formData.address}
//                     onChange={handleInputChange}
//                     rows="2"
//                     placeholder="Enter company address"
//                     className="form-textarea"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     rows="3"
//                     placeholder="Brief description about the company"
//                     className="form-textarea"
//                   />
//                 </div>
//               </div>
              
//               <div className="modal-footer">
//                 <button type="submit" className="btn-primary">
//                   {editingCompany ? 'Update Company' : 'Add Company'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { resetForm(); setShowModal(false); }}
//                   className="btn-secondary"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* View Company Modal */}
//       {showViewModal && viewingCompany && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Company Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingCompany(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-company-header">
//                 <div className="view-company-logo">
//                   {viewingCompany.name ? viewingCompany.name.charAt(0) : '?'}
//                 </div>
//                 <div className="view-company-title">
//                   <h3>{viewingCompany.name || 'Unknown Company'}</h3>
//                   <p>{viewingCompany.industry || 'Industry not specified'}</p>
//                 </div>
//                 <div className="view-company-badges">
//                   <span className={`company-status-badge ${viewingCompany.status === 'Active' ? 'active' : 'inactive'}`}>
//                     {viewingCompany.status || 'Active'}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Contact Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Contact Person:</span>
//                     <span className="detail-value">{viewingCompany.contact_person || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Email:</span>
//                     <span className="detail-value">
//                       <a href={`mailto:${viewingCompany.email}`}>{viewingCompany.email || 'Not specified'}</a>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Phone:</span>
//                     <span className="detail-value">{viewingCompany.phone || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Website:</span>
//                     <span className="detail-value">
//                       {viewingCompany.website ? (
//                         <a href={viewingCompany.website} target="_blank" rel="noopener noreferrer">
//                           {viewingCompany.website}
//                         </a>
//                       ) : 'Not specified'}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Company Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Industry:</span>
//                     <span className="detail-value">{viewingCompany.industry || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Founded Year:</span>
//                     <span className="detail-value">{viewingCompany.founded_year || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Status:</span>
//                     <span className="detail-value">{viewingCompany.status || 'Active'}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Address</h4>
//                   <div className="detail-value">
//                     {viewingCompany.address || 'No address provided'}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Description</h4>
//                   <div className="detail-value" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
//                     {viewingCompany.description || 'No description provided'}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingCompany(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
//               {isAdmin && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingCompany(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingCompany);
//                   }}
//                 >
//                   Edit Company
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Companies;









// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { getCompanies, createCompany, updateCompany, deleteCompany } from "../../services/api";
// import { useAuth } from "../../contexts/AuthContext";
// import './Companies.css';

// const Companies = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editingCompany, setEditingCompany] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterIndustry, setFilterIndustry] = useState('all');
//   const [filterStatus, setFilterStatus] = useState('all');
  
//   // View Modal States
//   const [viewingCompany, setViewingCompany] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";
  
//   const [formData, setFormData] = useState({
//     name: '',
//     industry: '',
//     contact_person: '',
//     email: '',
//     phone: '',
//     address: '',
//     city: '',
//     state: '',
//     status: 'Active',
//     website: '',
//     description: '',
//     founded_year: ''
//   });

//   useEffect(() => {
//     loadCompanies();
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterIndustry, filterStatus]);

//   const loadCompanies = async () => {
//     try {
//       const res = await getCompanies();
//       setCompanies(res.data);
//       setLoading(false);
//     } catch (error) {
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (editingCompany) {
//       await updateCompany(editingCompany.id, formData);
//     } else {
//       await createCompany(formData);
//     }
    
//     resetForm();
//     loadCompanies();
//     setShowModal(false);
//   };

//   // View handler for Company
//   const handleView = (company) => {
//     setViewingCompany(company);
//     setShowViewModal(true);
//   };

//   const handleEdit = (company) => {
//     // Only admin can edit
//     if (!isAdmin) {
//       alert("You don't have permission to edit companies");
//       return;
//     }
//     setEditingCompany(company);
//     setFormData(company);
//     setShowModal(true);
//   };

//   const handleDelete = async(id) => {
//     // Only admin can delete
//     if (!isAdmin) {
//       alert("You don't have permission to delete companies");
//       return;
//     }
//     if (window.confirm('Are you sure you want to delete this company?')) {
//       await deleteCompany(id);
//       loadCompanies();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       industry: '',
//       contact_person: '',
//       email: '',
//       phone: '',
//       address: '',
//       city: '',
//       state: '',
//       status: 'Active',
//       website: '',
//       description: '',
//       founded_year: ''
//     });
//     setEditingCompany(null);
//   };

//   // Filter companies - UPDATED with phone search
//   const filteredCompanies = companies.filter(company => {
//     const search = searchTerm.toLowerCase();
//     const name = company.name?.toLowerCase() || "";
//     const contactPerson = company.contact_person?.toLowerCase() || "";
//     const email = company.email?.toLowerCase() || "";
    
//     // Phone search handling - with null safety, numeric stripping, and partial match
//     let phoneMatch = false;
//     if (searchTerm && company.phone) {
//       const searchDigits = searchTerm.replace(/\D/g, "");
//       const phoneDigits = company.phone.toString().replace(/\D/g, "");
//       if (searchDigits && phoneDigits.includes(searchDigits)) {
//         phoneMatch = true;
//       }
//     }
    
//     const matchesSearch = !searchTerm || 
//       name.includes(search) ||
//       contactPerson.includes(search) ||
//       email.includes(search) ||
//       phoneMatch;
    
//     const matchesIndustry = filterIndustry === 'all' || company.industry === filterIndustry;
//     const matchesStatus = filterStatus === 'all' || company.status === filterStatus;
    
//     return matchesSearch && matchesIndustry && matchesStatus;
//   });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

//   // Pagination handlers
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   // Get unique industries and stats
//   const industries = ['all', ...new Set(companies.map(c => c.industry).filter(Boolean))];
//   const activeCompanies = companies.filter(c => c.status === 'Active').length;

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading companies...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="companies-page">
//       {/* Page Header */}
//       <div className="page-header">
//         <div className='comp'>
//           <h1>Companies</h1>
//           <p>Manage client companies and their details</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         {isAdmin && (
//           <button onClick={() => setShowModal(true)} className="btn-primary">
//             <span className="btn-icon">+</span> Add Company
//           </button>
//         )}
//       </div>

//       {/* Stats */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{companies.length}</h3>
//             <p>Total Companies</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{activeCompanies}</h3>
//             <p>Active Companies</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">📊</div>
//           <div className="stat-content">
//             <h3>{industries.length - 1}</h3>
//             <p>Industries</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Search companies by name, contact, email, or phone..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         <div className="filter-controls">
//           <select 
//             value={filterIndustry} 
//             onChange={(e) => setFilterIndustry(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Industries</option>
//             {industries.filter(i => i !== 'all').map(industry => (
//               <option key={industry} value={industry}>{industry}</option>
//             ))}
//           </select>
          
//           <select 
//             value={filterStatus} 
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//           </select>
//         </div>
//       </div>

//       {/* Companies Table with Pagination */}
//       <div className="table-container">
//         {filteredCompanies.length > 0 ? (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Company</th>
//                   <th>Industry</th>
//                   <th>Contact</th>
//                   <th>Email</th>
//                   <th>Phone</th>
//                   <th>City</th>
//                   <th>State</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map(company => (
//                   <tr key={company.id}>
//                     <td>
//                       <div className="company-cell">
//                         <div className="company-avatar">
//                           {company.name.charAt(0)}
//                         </div>
//                         <div className="company-info">
//                           <div className="company-name" style={{ cursor: 'pointer', color: '#0B5FA5', fontWeight: '500' }}>
//                             {company.name}
//                           </div>
//                           <span className="company-website">{company.website || 'No website'}</span>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <span className="industry-badge">{company.industry || 'N/A'}</span>
//                     </td>
//                     <td>{company.contact_person || 'N/A'}</td>
//                     <td>
//                       <a href={`mailto:${company.email}`} className="email-link">
//                         {company.email || 'N/A'}
//                       </a>
//                     </td>
//                     <td>{company.phone || 'N/A'}</td>
//                     <td>{company.city || 'N/A'}</td>
//                     <td>{company.state || 'N/A'}</td>
//                     <td>
//                       <span className={`status-badge ${company.status === 'Active' ? 'active' : 'inactive'}`}>
//                         {company.status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         {/* View Button - Opens Modal */}
//                         <button 
//                           onClick={() => handleView(company)} 
//                           className="action-btn view"
//                           title="View Company Details"
//                         >
//                           👁️
//                         </button>
                        
//                         {/* Edit Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleEdit(company)} 
//                             className="action-btn edit"
//                             title="Edit"
//                           >
//                             ✏️
//                           </button>
//                         )}
                        
//                         {/* Delete Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleDelete(company.id)} 
//                             className="action-btn delete"
//                             title="Delete"
//                           >
//                             🗑️
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCompanies.length)} of {filteredCompanies.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   {/* Page Numbers */}
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">🏢</div>
//             <h3>No companies found</h3>
//             <p>Try adding a new company or adjust your search filters</p>
//             {isAdmin && (
//               <button onClick={() => setShowModal(true)} className="btn-primary">
//                 Add Your First Company
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h2>{editingCompany ? 'Edit Company' : 'Add New Company'}</h2>
//               <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
//                 ×
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Company Name *</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       placeholder="Enter company name"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Industry *</label>
//                     <input
//                       type="text"
//                       name="industry"
//                       value={formData.industry}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Technology, Finance"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Contact Person *</label>
//                     <input
//                       type="text"
//                       name="contact_person"
//                       value={formData.contact_person}
//                       onChange={handleInputChange}
//                       placeholder="Enter contact person name"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Email *</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       placeholder="contact@company.com"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Phone</label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder="+91 9876543210"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Website</label>
//                     <input
//                       type="url"
//                       name="website"
//                       value={formData.website}
//                       onChange={handleInputChange}
//                       placeholder="https://company.com"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Founded Year</label>
//                     <input
//                       type="number"
//                       name="founded_year"
//                       value={formData.founded_year}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 2010"
//                       min="1900"
//                       max="2024"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Address</label>
//                   <textarea
//                     name="address"
//                     value={formData.address}
//                     onChange={handleInputChange}
//                     rows="2"
//                     placeholder="Enter company address"
//                     className="form-textarea"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>City</label>
//                   <input
//                     type="text"
//                     name="city"
//                     value={formData.city}
//                     onChange={handleInputChange}
//                     placeholder="Enter city"
//                     className="form-input"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>State</label>
//                   <input
//                     type="text"
//                     name="state"
//                     value={formData.state}
//                     onChange={handleInputChange}
//                     placeholder="Enter state"
//                     className="form-input"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     rows="3"
//                     placeholder="Brief description about the company"
//                     className="form-textarea"
//                   />
//                 </div>
//               </div>
              
//               <div className="modal-footer">
//                 <button type="submit" className="btn-primary">
//                   {editingCompany ? 'Update Company' : 'Add Company'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { resetForm(); setShowModal(false); }}
//                   className="btn-secondary"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* View Company Modal */}
//       {showViewModal && viewingCompany && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Company Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingCompany(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-company-header">
//                 <div className="view-company-logo">
//                   {viewingCompany.name ? viewingCompany.name.charAt(0) : '?'}
//                 </div>
//                 <div className="view-company-title">
//                   <h3>{viewingCompany.name || 'Unknown Company'}</h3>
//                   <p>{viewingCompany.industry || 'Industry not specified'}</p>
//                 </div>
//                 <div className="view-company-badges">
//                   <span className={`company-status-badge ${viewingCompany.status === 'Active' ? 'active' : 'inactive'}`}>
//                     {viewingCompany.status || 'Active'}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Contact Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Contact Person:</span>
//                     <span className="detail-value">{viewingCompany.contact_person || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Email:</span>
//                     <span className="detail-value">
//                       <a href={`mailto:${viewingCompany.email}`}>{viewingCompany.email || 'Not specified'}</a>
//                     </span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Phone:</span>
//                     <span className="detail-value">{viewingCompany.phone || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Website:</span>
//                     <span className="detail-value">
//                       {viewingCompany.website ? (
//                         <a href={viewingCompany.website} target="_blank" rel="noopener noreferrer">
//                           {viewingCompany.website}
//                         </a>
//                       ) : 'Not specified'}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Company Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Industry:</span>
//                     <span className="detail-value">{viewingCompany.industry || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Founded Year:</span>
//                     <span className="detail-value">{viewingCompany.founded_year || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Status:</span>
//                     <span className="detail-value">{viewingCompany.status || 'Active'}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Address</h4>
//                   <div className="detail-value">
//                     {viewingCompany.address || 'No address provided'}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>City & State</h4>
//                   <div className="detail-value">
//                     {viewingCompany.city || 'Not specified'}, {viewingCompany.state || 'Not specified'}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Description</h4>
//                   <div className="detail-value" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
//                     {viewingCompany.description || 'No description provided'}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingCompany(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
//               {isAdmin && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingCompany(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingCompany);
//                   }}
//                 >
//                   Edit Company
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Companies;




import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCompanies, createCompany, updateCompany, deleteCompany } from "../../services/api";
import { useAuth } from "../../contexts/AuthContext";
import './Companies.css';

const Companies = () => {
  // Get current user from AuthContext
  const { currentUser } = useAuth();
  
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterIndustry, setFilterIndustry] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  
  // View Modal States
  const [viewingCompany, setViewingCompany] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

  // Check if user is admin
  const isAdmin = currentUser && currentUser.role === "admin";
  
  const [formData, setFormData] = useState({
    name: '',
    industry: '',
    contact_person: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    status: 'Active',
    website: '',
    description: '',
    founded_year: ''
  });

  useEffect(() => {
    loadCompanies();
  }, []);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterIndustry, filterStatus]);

  const loadCompanies = async () => {
    try {
      const res = await getCompanies();
      setCompanies(res.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    const trimmedName = formData.name?.trim();
    const trimmedContactPerson = formData.contact_person?.trim();
    const trimmedPhone = formData.phone?.trim();
    const trimmedEmail = formData.email?.trim();
    
    // Check required fields
    if (!trimmedName) {
      alert("Company name is required");
      return;
    }
    
    if (!trimmedContactPerson) {
      alert("Contact person name is required");
      return;
    }
    
    // Check at least one contact method (phone or email)
    const hasPhone = trimmedPhone && trimmedPhone.length > 0;
    const hasEmail = trimmedEmail && trimmedEmail.length > 0;
    
    if (!hasPhone && !hasEmail) {
      alert("Either mobile number or email is required");
      return;
    }
    
    // Validate email format if provided
    if (hasEmail) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedEmail)) {
        alert("Please enter a valid email address");
        return;
      }
    }
    
    // Validate phone if provided
    if (hasPhone) {
      const phoneDigits = trimmedPhone.replace(/\D/g, "");
      if (phoneDigits.length < 10) {
        alert("Please enter a valid phone number with at least 10 digits");
        return;
      }
    }
    
    // Update formData with trimmed values before submission
    const submitData = {
      ...formData,
      name: trimmedName,
      contact_person: trimmedContactPerson,
      phone: trimmedPhone || "",
      email: trimmedEmail || ""
    };
    
    try {
      if (editingCompany) {
        await updateCompany(editingCompany.id, submitData);
      } else {
        await createCompany(submitData);
      }
      
      resetForm();
      loadCompanies();
      setShowModal(false);
    } catch (error) {
      console.error("Error saving company:", error);
      alert("Failed to save company. Please try again.");
    }
  };

  // View handler for Company
  const handleView = (company) => {
    setViewingCompany(company);
    setShowViewModal(true);
  };

  const handleEdit = (company) => {
    // Only admin can edit
    if (!isAdmin) {
      alert("You don't have permission to edit companies");
      return;
    }
    setEditingCompany(company);
    setFormData(company);
    setShowModal(true);
  };

  const handleDelete = async(id) => {
    // Only admin can delete
    if (!isAdmin) {
      alert("You don't have permission to delete companies");
      return;
    }
    if (window.confirm('Are you sure you want to delete this company?')) {
      await deleteCompany(id);
      loadCompanies();
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      industry: '',
      contact_person: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      status: 'Active',
      website: '',
      description: '',
      founded_year: ''
    });
    setEditingCompany(null);
  };

  // Filter companies - UPDATED with phone search
  const filteredCompanies = companies.filter(company => {
    const search = searchTerm.toLowerCase();
    const name = company.name?.toLowerCase() || "";
    const contactPerson = company.contact_person?.toLowerCase() || "";
    const email = company.email?.toLowerCase() || "";
    
    // Phone search handling - with null safety, numeric stripping, and partial match
    let phoneMatch = false;
    if (searchTerm && company.phone) {
      const searchDigits = searchTerm.replace(/\D/g, "");
      const phoneDigits = company.phone.toString().replace(/\D/g, "");
      if (searchDigits && phoneDigits.includes(searchDigits)) {
        phoneMatch = true;
      }
    }
    
    const matchesSearch = !searchTerm || 
      name.includes(search) ||
      contactPerson.includes(search) ||
      email.includes(search) ||
      phoneMatch;
    
    const matchesIndustry = filterIndustry === 'all' || company.industry === filterIndustry;
    const matchesStatus = filterStatus === 'all' || company.status === filterStatus;
    
    return matchesSearch && matchesIndustry && matchesStatus;
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

  // Pagination handlers
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Get unique industries and stats
  const industries = ['all', ...new Set(companies.map(c => c.industry).filter(Boolean))];
  const activeCompanies = companies.filter(c => c.status === 'Active').length;

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading companies...</p>
      </div>
    );
  }

  return (
    <div className="companies-page">
      {/* Page Header */}
      <div className="page-header">
        <div className='comp'>
          <h1>Companies</h1>
          <p>Manage client companies and their details</p>
          {!isAdmin && (
            <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
          )}
        </div>
        {isAdmin && (
          <button onClick={() => setShowModal(true)} className="btn-primary">
            <span className="btn-icon">+</span> Add Company
          </button>
        )}
      </div>

      {/* Stats */}
      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-icon">🏢</div>
          <div className="stat-content">
            <h3>{companies.length}</h3>
            <p>Total Companies</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>{activeCompanies}</h3>
            <p>Active Companies</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>{industries.length - 1}</h3>
            <p>Industries</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search companies by name, contact, email, or phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>
        
        <div className="filter-controls">
          <select 
            value={filterIndustry} 
            onChange={(e) => setFilterIndustry(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Industries</option>
            {industries.filter(i => i !== 'all').map(industry => (
              <option key={industry} value={industry}>{industry}</option>
            ))}
          </select>
          
          <select 
            value={filterStatus} 
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>

      {/* Companies Table with Pagination */}
      <div className="table-container">
        {filteredCompanies.length > 0 ? (
          <>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Industry</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map(company => (
                  <tr key={company.id}>
                    <td>
                      <div className="company-cell">
                        <div className="company-avatar">
                          {company.name.charAt(0)}
                        </div>
                        <div className="company-info">
                          <div className="company-name" style={{ cursor: 'pointer', color: '#0B5FA5', fontWeight: '500' }}>
                            {company.name}
                          </div>
                          <span className="company-website">{company.website || 'No website'}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="industry-badge">{company.industry || 'N/A'}</span>
                    </td>
                    <td>{company.contact_person || 'N/A'}</td>
                    <td>
                      <a href={`mailto:${company.email}`} className="email-link">
                        {company.email || 'N/A'}
                      </a>
                    </td>
                    <td>{company.phone || 'N/A'}</td>
                    <td>{company.city || 'N/A'}</td>
                    <td>{company.state || 'N/A'}</td>
                    <td>
                      <span className={`status-badge ${company.status === 'Active' ? 'active' : 'inactive'}`}>
                        {company.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        {/* View Button - Opens Modal */}
                        <button 
                          onClick={() => handleView(company)} 
                          className="action-btn view"
                          title="View Company Details"
                        >
                          👁️
                        </button>
                        
                        {/* Edit Button - Only visible to admin */}
                        {isAdmin && (
                          <button 
                            onClick={() => handleEdit(company)} 
                            className="action-btn edit"
                            title="Edit"
                          >
                            ✏️
                          </button>
                        )}
                        
                        {/* Delete Button - Only visible to admin */}
                        {isAdmin && (
                          <button 
                            onClick={() => handleDelete(company.id)} 
                            className="action-btn delete"
                            title="Delete"
                          >
                            🗑️
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="pagination-container">
              <div className="pagination-info">
                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredCompanies.length)} of {filteredCompanies.length} entries
              </div>
              
              <div className="pagination-controls">
                <div className="items-per-page">
                  <label>Show:</label>
                  <select 
                    value={itemsPerPage} 
                    onChange={handleItemsPerPageChange}
                    className="items-per-page-select"
                  >
                    {itemsPerPageOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                
                <div className="pagination-buttons">
                  <button 
                    onClick={goToPreviousPage} 
                    disabled={currentPage === 1}
                    className="pagination-btn prev"
                  >
                    &laquo; Previous
                  </button>
                  
                  {/* Page Numbers */}
                  <div className="page-numbers">
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      if (
                        pageNumber === 1 ||
                        pageNumber === totalPages ||
                        (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                      ) {
                        return (
                          <button
                            key={pageNumber}
                            onClick={() => paginate(pageNumber)}
                            className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
                          >
                            {pageNumber}
                          </button>
                        );
                      } else if (
                        pageNumber === currentPage - 3 ||
                        pageNumber === currentPage + 3
                      ) {
                        return <span key={pageNumber} className="page-ellipsis">...</span>;
                      }
                      return null;
                    })}
                  </div>
                  
                  <button 
                    onClick={goToNextPage} 
                    disabled={currentPage === totalPages}
                    className="pagination-btn next"
                  >
                    Next &raquo;
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">🏢</div>
            <h3>No companies found</h3>
            <p>Try adding a new company or adjust your search filters</p>
            {isAdmin && (
              <button onClick={() => setShowModal(true)} className="btn-primary">
                Add Your First Company
              </button>
            )}
          </div>
        )}
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>{editingCompany ? 'Edit Company' : 'Add New Company'}</h2>
              <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
                ×
              </button>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Company Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter company name"
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Industry</label>
                    <input
                      type="text"
                      name="industry"
                      value={formData.industry}
                      onChange={handleInputChange}
                      placeholder="e.g., Technology, Finance"
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Contact Person *</label>
                    <input
                      type="text"
                      name="contact_person"
                      value={formData.contact_person}
                      onChange={handleInputChange}
                      placeholder="Enter contact person name"
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="contact@company.com"
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+91 9876543210"
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Website</label>
                    <input
                      type="url"
                      name="website"
                      value={formData.website}
                      onChange={handleInputChange}
                      placeholder="https://company.com"
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Founded Year</label>
                    <input
                      type="number"
                      name="founded_year"
                      value={formData.founded_year}
                      onChange={handleInputChange}
                      placeholder="e.g., 2010"
                      min="1900"
                      max="2024"
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Status</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label>Address</label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows="2"
                    placeholder="Enter company address"
                    className="form-textarea"
                  />
                </div>

                <div className="form-group">
                  <label>City</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="Enter city"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label>State</label>
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    placeholder="Enter state"
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    rows="3"
                    placeholder="Brief description about the company"
                    className="form-textarea"
                  />
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="submit" className="btn-primary">
                  {editingCompany ? 'Update Company' : 'Add Company'}
                </button>
                <button 
                  type="button" 
                  onClick={() => { resetForm(); setShowModal(false); }}
                  className="btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Company Modal */}
      {showViewModal && viewingCompany && (
        <div className="modal-overlay">
          <div className="modal-content modal-lg">
            <div className="modal-header">
              <h2>Company Details</h2>
              <button
                className="modal-close"
                onClick={() => {
                  setViewingCompany(null);
                  setShowViewModal(false);
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="view-company-header">
                <div className="view-company-logo">
                  {viewingCompany.name ? viewingCompany.name.charAt(0) : '?'}
                </div>
                <div className="view-company-title">
                  <h3>{viewingCompany.name || 'Unknown Company'}</h3>
                  <p>{viewingCompany.industry || 'Industry not specified'}</p>
                </div>
                <div className="view-company-badges">
                  <span className={`company-status-badge ${viewingCompany.status === 'Active' ? 'active' : 'inactive'}`}>
                    {viewingCompany.status || 'Active'}
                  </span>
                </div>
              </div>

              <div className="view-details-grid">
                <div className="view-details-section">
                  <h4>Contact Information</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Contact Person:</span>
                    <span className="detail-value">{viewingCompany.contact_person || 'Not specified'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">
                      <a href={`mailto:${viewingCompany.email}`}>{viewingCompany.email || 'Not specified'}</a>
                    </span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Phone:</span>
                    <span className="detail-value">{viewingCompany.phone || 'Not specified'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Website:</span>
                    <span className="detail-value">
                      {viewingCompany.website ? (
                        <a href={viewingCompany.website} target="_blank" rel="noopener noreferrer">
                          {viewingCompany.website}
                        </a>
                      ) : 'Not specified'}
                    </span>
                  </div>
                </div>

                <div className="view-details-section">
                  <h4>Company Information</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Industry:</span>
                    <span className="detail-value">{viewingCompany.industry || 'Not specified'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Founded Year:</span>
                    <span className="detail-value">{viewingCompany.founded_year || 'Not specified'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Status:</span>
                    <span className="detail-value">{viewingCompany.status || 'Active'}</span>
                  </div>
                </div>

                <div className="view-details-section full-width">
                  <h4>Address</h4>
                  <div className="detail-value">
                    {viewingCompany.address || 'No address provided'}
                  </div>
                </div>

                <div className="view-details-section full-width">
                  <h4>City & State</h4>
                  <div className="detail-value">
                    {viewingCompany.city || 'Not specified'}, {viewingCompany.state || 'Not specified'}
                  </div>
                </div>

                <div className="view-details-section full-width">
                  <h4>Description</h4>
                  <div className="detail-value" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
                    {viewingCompany.description || 'No description provided'}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => {
                  setViewingCompany(null);
                  setShowViewModal(false);
                }}
              >
                Close
              </button>
              {isAdmin && (
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    setViewingCompany(null);
                    setShowViewModal(false);
                    handleEdit(viewingCompany);
                  }}
                >
                  Edit Company
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Companies;